export default __webpack_public_path__ + "static/media/icon-user-active.b2de9a93.svg";